import React from "react";

import { css } from "@emotion/react";

const ContentWrapper = ({ children }) => {
    return <div>{children}</div>;
};

const list = css`
    margin-left: 18px !important;
`;

const List = ({
    children,
    type = "unordered",
    withContentWrapper = false,
    listStyleType = "disc",
    ...props
}) => {
    const listTypeStyles = css`
        list-style-type: ${listStyleType};
    `;

    const Tag = type === "unordered" ? "ul" : "ol";

    const element = (
        <Tag
            css={css`
                ${list}
                ${listTypeStyles}
            `}
            {...props}
        >
            {children}
        </Tag>
    );

    if (withContentWrapper) {
        return <ContentWrapper>{element}</ContentWrapper>;
    }

    return element;
};

const Item = ({ children }) => {
    return <li>{children}</li>;
};

List.Item = Item;

export default List;
